import * as mutationTypes from './types/mutation_types';

import initialState from './initialState';

export default {
  [mutationTypes.STORAGE_REQUEST](state) {
    Object.assign(state, { loading: true, error: null });
  },
  [mutationTypes.STORAGE_SUCCESS](state, payload) {
    Object.assign(state, { loading: false, data: payload });
  },
  [mutationTypes.STORAGE_ERROR](state, payload) {
    Object.assign(state, {
      loading: false,
      data: null,
      error: payload || true,
    });
  },
  [mutationTypes.STORAGE_RESET](state) {
    Object.assign(state, ...initialState);
  },
  [mutationTypes.STORAGE_SELECT](state, payload) {
    Object.assign(state, { selected: payload });
  },
  [mutationTypes.STORAGE_SELECT_RESET](state) {
    Object.assign(state, { selected: { title: '' } });
  },
};
